<!-- 
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.  
 -->
<div class="sidebar" *ngIf="verifyAcls(acls.TWOFA_EMAIL_VIEW)">
    <ul class="nav flex-column">
        <li class="nav-item mb-3">
            <ul class="nav flex-column nav-home">
                <li>
                    <a id="sidebar_contact-info"
                        title=""
                        (click)="openRoute()"
                        class="nav-link rounded"
                        [routerLink]="['/', currentCompany, 'security', 'managedetails']"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        [innerHTML]="'sidebar.home.sectionTitle' | translate"></a>
                </li>
            </ul>
      </li>
    </ul>
    <ul class="nav flex-column">
        <li class="nav-item  mb-3">
            <span class="nav-link main">
                <!--  CONTATTI ACCOUNT PEC -->
                <svg-icon src="content/images/icons/utente.svg" 
                    [svgStyle]="{ 'width.px':'16', 'height.px':'16', 'vertical-align': 'bottom' }">
                </svg-icon>
                <span [innerHTML]="'sidebar.contactAccountPec.sectionTitle' | translate"></span>
            </span>
            <ul class="nav flex-column ps-4">
                <li>
                    <a id="sidebar_email-mobile-info"
                        title=""
                        (click)="openRoute()"
                        class="nav-link rounded"
                        [routerLink]="['/', currentCompany, 'security', 'contactdetails']"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        [innerHTML]="'sidebar.contactAccountPec.contactDetail' | translate"></a>
                </li>
            </ul>
        </li>
    </ul>
    <ul class="nav flex-column">
        <li class="nav-item  mb-3">
            <span class="nav-link main" *apHasAnyAcl="[acls.PASSWORD_CHANGE_VIEW, acls.PASSWORD_EXPIRATION_CONFIG_VIEW, 
                acls.TWOFA_APP_VIEW, acls.TWOFA_SMS_VIEW, acls.ACCESSLOG_VIEW, acls.CLIENT_API]">
                <!-- Sicurezza -->
                <svg-icon src="content/images/icons/icona - lucchetto.svg" [svgStyle]="{ 'width.px':'16', 
                'height.px':'16', 'vertical-align': 'bottom' }"></svg-icon>
                <span [innerHTML]="'sidebar.security.sectionTitle' | translate"></span>
            </span>
            <ul class="nav flex-column ps-4">
                <ng-container *apHasAnyAcl="[acls.PASSWORD_CHANGE_VIEW, acls.PASSWORD_EXPIRATION_CONFIG_VIEW, 
                acls.TWOFA_APP_VIEW, acls.TWOFA_SMS_VIEW, acls.ACCESSLOG_VIEW, acls.CLIENT_API, acls.DOCAPOSTE_VIEW]">
                    <ng-container *ngIf="appConfig.twoFaEnabled && isTwoFAStatus">
                    <li class="mb-1">
                        <a  *apHasAnyAcl="[acls.PASSWORD_CHANGE_VIEW, acls.CLIENT_API]"
                        title=""
                        (click)="openRoute()"
                        class="nav-link rounded"
                        [routerLink]="['/', currentCompany, 'security', 'changepassword']"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        [innerHTML]="'sidebar.security.changePassword' | translate"></a>
                    </li>
                    <ng-container *ngIf="((isMultiutente && hasClientThirdParts) || !isMultiutente)">
                    <li class="mb-1">
                        <a *apHasAnyAcl="[acls.CLIENT_API]"
                        title=""
                        (click)="openRoute()"
                        class="nav-link rounded"
                        [routerLink]="['/', currentCompany, 'security', 'programpassword']"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        [innerHTML]="'sidebar.security.changePasswordProg' | translate"></a>
                    </li>
                    </ng-container>
                    </ng-container>
                    <ng-container *ngIf="!appConfig.twoFaEnabled || !isTwoFAStatus">
                    <!-- CASO 2: 2FA non attiva, scadenza pw non attiva -->
                    <li class="mb-1">
                        <a title=""
                        (click)="openRoute()"
                        class="nav-link rounded"
                        [routerLink]="['/', currentCompany, 'security', 'changepassword']"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        [innerHTML]="'sidebar.security.detailPasswordPEC' | translate"></a>
                    </li>
                    </ng-container>
                   
                    <ng-container *apHasAnyAcl="[acls.TWOFA_APP_VIEW, acls.TWOFA_SMS_VIEW]">
                        <li class="mb-1" *ngIf="appConfig.twoFaEnabled && verifyAcls(acls.DOCAPOSTE_VIEW)">
                            <a  (click)="openRoute()"
                                title=""
                                class="nav-link rounded"
                                [routerLink]="['/', currentCompany, 'security', '2stepverification']"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }"
                                [innerHTML]="'sidebar.security.twoFactorAuth' | translate"></a>
                        </li>
                    </ng-container>
                    <li class="mb-1">
                        <a *apHasAnyAcl="acls.ACCESSLOG_VIEW"
                            title=""
                            (click)="openRoute()"
                            class="nav-link rounded"
                            [routerLink]="['/', currentCompany, 'security', 'loginhistory']"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }"
                            [innerHTML]="'sidebar.security.accessLog' | translate"></a>
                    </li>
                    <ng-container *ngIf="visBeta">
                    <li class="mb-1">
                        <a (click)="openRoute()"
                            title=""
                            class="nav-link rounded"
                            [routerLink]="['/', currentCompany, 'security', 'securitycommunications']"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }">
                            {{ 'sidebar.security.securityCommunications' | translate }}</a>
                    </li>
                    </ng-container>

                </ng-container>
            </ul>
        </li>
    </ul>
</div>
